import { loan_application_api } from '@axo/shared/data-access/api';
import { useAPI } from '@axo/shared/data-access/provider';
import { useMutation, useQueryClient } from 'react-query';
import { applicationAssignmentKeys } from '../cache-keys/applicationAssignmentKeys';
import { rootKeys } from '../cache-keys/rootKeys';

export function useDeleteCoApplicant() {
  const client = useQueryClient();
  const api = useAPI();

  return useMutation(
    loan_application_api.deleteLoanApplicationCoApplicant(api),
    {
      onSuccess: async (loanApplication) => {
        await Promise.all([
          client.invalidateQueries(
            applicationAssignmentKeys.root({
              applicationID: loanApplication.ID,
              marketCountry: loanApplication.MarketCountry,
            }),
          ),
          client.invalidateQueries(rootKeys.searchIndex()),
        ]);
      },
    },
  );
}
